import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useFetch } from "../lib/hooks";
import { useAuth } from "../context/AuthContext";
import { PageTitle, Panel, btnPrimary } from "./ui";
import { BrandLoader } from "../components/site/Logo";

const Row = ({ c, on, toggle }) => (
  <tr className="border-t border-border" data-testid={`catdraft-row-${c.slug}`}>
    <td className="py-2 pr-2"><input type="checkbox" checked={on} onChange={toggle} disabled={!c.unused_sources} aria-label={c.name} data-testid={`catdraft-check-${c.slug}`} /></td>
    <td className="py-2 pr-3 font-medium">{c.name}</td>
    <td className="py-2 pr-3 text-right">{c.published}</td>
    <td className="py-2 pr-3 text-right">{c.drafts}</td>
    <td className="py-2 pr-3 text-right">{c.unused_sources} / {c.sources}</td>
    <td className="py-2 pr-3 text-right">{c.queued}{c.failed ? <span className="ml-1 text-destructive">({c.failed} greška)</span> : null}</td>
  </tr>
);

export default function CategoryDrafts() {
  const { data, reload } = useFetch("/admin/ai-redakcija/kategorije");
  const { can } = useAuth();
  const [sel, setSel] = useState([]);
  const [per, setPer] = useState(2);
  const [busy, setBusy] = useState(false);
  if (!data) return <BrandLoader />;
  const toggle = (s) => setSel(sel.includes(s) ? sel.filter((x) => x !== s) : [...sel, s]);
  const run = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/admin/ai-redakcija/kategorije", { categories: sel, per_category: per });
      toast.success(`U red stavljeno nacrta: ${r.queued}. AI ih piše u pozadini.`);
      setSel([]); reload();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="category-drafts-page">
      <PageTitle title="AI nacrti po kategorijama" sub="AI piše trajno korisne tekstove isključivo iz službenih izvora u registru. Nijedan tekst se ne objavljuje bez ljudskog odobrenja." />
      <div className="mb-4 grid gap-3 sm:grid-cols-3">
        <Panel title="Objavljeno" testId="catdraft-published"><p className="text-2xl font-semibold">{data.published_total} / {data.target}</p></Panel>
        <Panel title="AI trošak danas" testId="catdraft-budget"><p className="text-2xl font-semibold">{data.spent_today_usd} USD</p><p className="text-xs text-muted-foreground">Dnevni limit: {data.budget_daily_usd ?? "—"} USD</p></Panel>
        <Panel title="Pregled nacrta" testId="catdraft-inbox"><Link to="/admin/ai-redakcija/za-pregled" className="underline">Otvori AI nacrte za pregled</Link></Panel>
      </div>
      <Panel title="Kategorije" testId="catdraft-table">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase text-muted-foreground"><th /><th className="py-2">Kategorija</th><th className="text-right">Objavljeno</th><th className="text-right">AI nacrti</th><th className="text-right">Slobodni izvori</th><th className="text-right">U redu</th></tr></thead>
            <tbody>{data.categories.map((c) => <Row key={c.slug} c={c} on={sel.includes(c.slug)} toggle={() => toggle(c.slug)} />)}</tbody>
          </table>
        </div>
        <p className="mt-3 text-xs text-muted-foreground">Kategorija bez slobodnih izvora traži nove službene izvore u registru (Izvori). Jedan izvor daje najviše jedan nacrt.</p>
        {can("newsroom.draft") && (
          <div className="mt-4 flex flex-wrap items-center gap-3">
            <label className="text-sm">Nacrta po kategoriji
              <select value={per} onChange={(e) => setPer(Number(e.target.value))} className="ml-2 rounded border border-border bg-background px-2 py-1" data-testid="catdraft-per-select">
                {[1, 2, 3, 4, 5].map((n) => <option key={n} value={n}>{n}</option>)}
              </select>
            </label>
            <button onClick={run} disabled={!sel.length || busy} className={btnPrimary} data-testid="catdraft-generate-button">{busy ? "Šaljem…" : "Pripremi AI nacrte"}</button>
          </div>
        )}
      </Panel>
    </div>
  );
}
